// ======================================================================
// File Name       : group
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../constants/actionTypes/group';
import { MODE } from '../constants';
import { USER_TYPE } from '../constants/UserConstants';
import store from '../store';

const editingInitalState = {
  editingGroup: { groupName: '' },
  editType: MODE.NEW_MODE,

  searchConditionAdmin: {userAttributeKeyNum: 1},
  searchResultAdmin: {
    startPosition: 0,
    searched: false,
    recordNum: 0,
    bySecernId: {},
    allSecernIds: [],
  },

  storedUserSearchResult: {
    bySecernId: {},
    allSecernIds: [],
  },

  searchConditionNotAdmin: { userType: USER_TYPE.STUDENT, userAttributeKeyNum: 1 },
  searchResultNotAdmin: {
    startPosition: 0,
    searched: false,
    recordNum: 0,
    bySecernId: {},
    allSecernIds: [],
  },
};

const INITAL_STATE = {
  structures: {
    bySecernId: {}, // group info + child: []
    allSecernIds: [], // only level 1
  },
  groupList: [],
  storedUserGroup: {}, // ex: "user001": {}

  ...editingInitalState,

  editingUserGroupAdmin: {}, // ex: "user001": {"name": "user1"}
  editingUserGroupNotAdmin: {}, // ex: "user001": {"name": "user1"}
  selectedTargetGroupIds: [],

  recordNumUserInGroup: 0,
};

export default function group(state = INITAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.GROUP_RECEIVE_STRUCTURE_LIST: {
      let { structureList } = action;
      if (!structureList || !structureList.length) {
        structureList = [];
      }
      const newState = structureList.reduce(
        (acc, cur) => {
          const { groupSecernId, parentGroupSecernId } = cur;
          acc.structures.bySecernId[groupSecernId] = cur;
          acc.structures.allSecernIds.push(groupSecernId);
          return acc;
        },
        { structures: { bySecernId: {}, allSecernIds: [] } },
      );

      return { ...state, ...newState, groupList: structureList };
    }

    case ActionTypes.GROUP_INIT_EDITING: {
      const { groupSecernId, parentGroupSecernId } = action;
      const newEditingGroup = {
        ...INITAL_STATE.editingGroup,
        ...state.structures.bySecernId[groupSecernId],
      };
      if (parentGroupSecernId) newEditingGroup.parentGroupSecernId = parentGroupSecernId;

      return {
        ...state,
        ...editingInitalState,
        editingGroup: newEditingGroup,
        editType: groupSecernId ? MODE.EDIT_MODE : MODE.NEW_MODE,
      };
    }

    case ActionTypes.GROUP_RESET_INIT_DATA: {
      const editingGroup = { groupName: '' };
      const editType = MODE.NEW_MODE;
      const editingUserGroupAdmin = {};
      const editingUserGroupNotAdmin = {};
      const storedUserGroup = {};
      return {
        ...state,
        ...editingInitalState,
        editingGroup,
        editType,
        editingUserGroupAdmin,
        editingUserGroupNotAdmin,
        storedUserGroup,
        recordNumUserInGroup: 0,
      };
    }

    case ActionTypes.GROUP_RECEIVE_EDITING_GROUP: {
      const { payload } = action;
      return {
        ...state,
        editingGroup: { ...state.editingGroup, ...payload },
      };
    }

    case ActionTypes.GROUP_RECEIVE_USER_GROUP: {
      const { userList, recordNumUserInGroup } = action;
      const newState = userList.reduce(
        (acc, cur) => {
          const { userSecernId, userType } = cur;
          acc.storedUserGroup[userSecernId] = cur;
          if (userType === USER_TYPE.ADMIN) {
            acc.editingUserGroupAdmin[userSecernId] = cur;
          } else {
            acc.editingUserGroupNotAdmin[userSecernId] = cur;
          }
          acc.recordNumUserInGroup = recordNumUserInGroup;
          return acc;
        },
        {
          storedUserGroup: {},
          editingUserGroupAdmin: {},
          editingUserGroupNotAdmin: {},
          recordNumUserInGroup: 0,
        },
      );

      return { ...state, ...newState };
    }

    case ActionTypes.GROUP_RECEIVE_EDITING_USER_ADMIN: {
      const { removedSecern, addedList, removedAll } = action;
      const stores = store.getState();
      const { authedUser } = stores.authed;
      const { userInfo } = authedUser;
      if (removedAll) {
        if (state.editType === MODE.EDIT_MODE) {
          const admin = { ...state.editingUserGroupAdmin[userInfo.userSecernId] };
          // If admin in editingUserGroupAdmin and in EDIT_MODE, do not remove admin
          if (admin && Object.keys(admin).length > 0) {
            const editingUserGroupAdmin = {};
            editingUserGroupAdmin[userInfo.userSecernId] = admin;
            return {
              ...state,
              editingUserGroupAdmin,
            };
          }
        }
        return {
          ...state,
          editingUserGroupAdmin: {},
        };
      }
      const editingUserGroupAdmin = { ...state.editingUserGroupAdmin };
      delete editingUserGroupAdmin[removedSecern];
      const users = state.storedUserSearchResult.bySecernId;
      addedList.forEach((userSecernId, index) => {
        if (users && users[userSecernId]) {
          editingUserGroupAdmin[userSecernId] = users[userSecernId];
          editingUserGroupAdmin[userSecernId].addNew = true;
          editingUserGroupAdmin[userSecernId].index = index;
        }
      });
      return {
        ...state,
        editingUserGroupAdmin,
      };
    }

    case ActionTypes.GROUP_RECEIVE_SEARCH_CONDITION_ADMIN: {
      const { payload } = action;
      return {
        ...state,
        searchConditionAdmin: { ...state.searchConditionAdmin, ...payload },
      };
    }

    case ActionTypes.GROUP_RECEIVE_SEARCH_RESULT_ADMIN: {
      const { startPosition, recordNum, userList } = action;
      const { storedUserSearchResult } = state;
      const searchResultAdmin = userList.reduce(
        (acc, cur) => {
          const { userSecernId } = cur;
          acc.bySecernId[userSecernId] = cur;
          acc.allSecernIds.push(userSecernId);
          if (!storedUserSearchResult.bySecernId[userSecernId]) {
            storedUserSearchResult.bySecernId[userSecernId] = cur;
          }
          if (storedUserSearchResult.allSecernIds.indexOf(userSecernId) < 0) {
            storedUserSearchResult.allSecernIds.push(userSecernId);
          }
          return acc;
        },
        { startPosition, searched: true, recordNum, bySecernId: {}, allSecernIds: [] },
      );
      return {
        ...state,
        searchResultAdmin,
        storedUserSearchResult,
      };
    }

    case ActionTypes.GROUP_RECEIVE_EDITING_USER_NOT_ADMIN: {
      const { removedSecern, addedList, removedAll } = action;
      if (removedAll) {
        return {
          ...state,
          editingUserGroupNotAdmin: {},
        };
      }
      const editingUserGroupNotAdmin = { ...state.editingUserGroupNotAdmin };
      delete editingUserGroupNotAdmin[removedSecern];
      const users = state.storedUserSearchResult.bySecernId;
      addedList.forEach((userSecernId, index) => {
        if (users && users[userSecernId]) {
          editingUserGroupNotAdmin[userSecernId] = users[userSecernId];
          editingUserGroupNotAdmin[userSecernId].addNew = true;
          editingUserGroupNotAdmin[userSecernId].index = index;
        }
      });
      return {
        ...state,
        editingUserGroupNotAdmin,
      };
    }

    case ActionTypes.GROUP_RECEIVE_SEARCH_CONDITION_NOT_ADMIN: {
      const { payload } = action;
      return {
        ...state,
        searchConditionNotAdmin: { ...state.searchConditionNotAdmin, ...payload },
      };
    }

    case ActionTypes.GROUP_RECEIVE_SEARCH_RESULT_NOT_ADMIN: {
      const { startPosition, recordNum, userList } = action;
      const { storedUserSearchResult } = state;
      const searchResultNotAdmin = userList && userList.reduce(
        (acc, cur) => {
          const { userSecernId } = cur;
          acc.bySecernId[userSecernId] = cur;
          acc.allSecernIds.push(userSecernId);
          if (!storedUserSearchResult.bySecernId[userSecernId]) {
            storedUserSearchResult.bySecernId[userSecernId] = cur;
          }
          if (storedUserSearchResult.allSecernIds.indexOf(userSecernId) < 0) {
            storedUserSearchResult.allSecernIds.push(userSecernId);
          }
          return acc;
        },
        { startPosition, searched: true, recordNum, bySecernId: {}, allSecernIds: [] },
      );
      return {
        ...state,
        searchResultNotAdmin,
        storedUserSearchResult,
      };
    }

    case ActionTypes.SELECTED_GROUP_ON_DIALOG: {
      const { selectedTargetGroup } = action;
      return {
        ...state,
        selectedTargetGroup,
      };
    }

    case ActionTypes.SELECTED_GROUP_IDS_ON_DIALOG: {
      const { selectedTargetGroupIds } = action;
      return {
        ...state,
        selectedTargetGroupIds,
      };
    }

    case ActionTypes.REMOVED_SELECTED_GROUP: {
      return {
        ...state,
        selectedTargetGroup: null,
      };
    }

    case ActionTypes.REMOVE_GROUP_LIST: {
      return {
        ...state,
        groupList: [],
        structures: {
          bySecernId: {}, // group info + child: []
          allSecernIds: [], // only level 1
        },
      };
    }

    case ActionTypes.REMOVED_SELECTED_GROUP_IDS: {
      return {
        ...state,
        selectedTargetGroupIds: [],
      };
    }

    default:
      return state;
  }
}
